/**
 * Almacenamiento de la sesión (token JWT + usuario). Fuente única: nadie más
 * debe leer ni escribir estas claves.
 *
 * Vive en `sessionStorage`, no en `localStorage` (usuario final, 28-sep-2026:
 * «cuando abren el ERP con su usuario, se abre con el usuario de otro
 * compañero»). En `localStorage` la sesión sobrevivía 8 h al cierre del
 * navegador: en un equipo compartido, el siguiente que abría el ERP entraba
 * como el anterior. `sessionStorage` muere al cerrar el navegador y es propio
 * de cada pestaña.
 */
const TOKEN_KEY = 'token';
const USER_KEY = 'user';

function almacen(): Storage | null {
  try {
    return window.sessionStorage;
  } catch {
    return null; // storage bloqueado (modo privado estricto, políticas)
  }
}

/** Borra la sesión que versiones anteriores dejaban en `localStorage`, para que
 *  no quede un token vivo en el equipo tras el cambio. Idempotente. */
export function purgarSesionAntigua(): void {
  try {
    window.localStorage.removeItem(TOKEN_KEY);
    window.localStorage.removeItem(USER_KEY);
  } catch {
    /* storage bloqueado */
  }
}

export function leerToken(): string | null {
  return almacen()?.getItem(TOKEN_KEY) ?? null;
}

export function leerUsuario<T>(): T | null {
  const raw = almacen()?.getItem(USER_KEY);
  if (!raw) return null;
  try {
    return JSON.parse(raw) as T;
  } catch {
    return null;
  }
}

export function guardarSesion(token: string, usuario: unknown): void {
  const s = almacen();
  if (!s) return;
  s.setItem(TOKEN_KEY, token);
  s.setItem(USER_KEY, JSON.stringify(usuario));
}

export function borrarSesion(): void {
  const s = almacen();
  s?.removeItem(TOKEN_KEY);
  s?.removeItem(USER_KEY);
}
